// extracted by mini-css-extract-plugin
export var actionButton = "_op-0";
export var actionMenuContainer = "_op-i";
export var bubble = "_op-2";
export var bubbleActionMenu = "_op-j";
export var bubbleContext = "_op-6";
export var bubbleItems = "_op-7";
export var customer = "_op-3";
export var divider = "_op-8";
export var fileList = "_op-9";
export var hiddenComment = "_op-o";
export var infoAbove = "_op-a";
export var internal = "_op-4";
export var lightActionButton = "_op-1";
export var link = "_op-b";
export var merchant = "_op-5";
export var message = "_op-c";
export var profilePicture = "_op-e";
export var quillToolbarContainer = "_op-f";
export var senderDate = "_op-g";
export var senderDateCustomer = "_op-h";
export var senderName = "_op-d";
export var time = "_op-k";
export var uploadedImage = "_op-l";
export var username = "_op-m";
export var xsmall = "_op-n";